const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Scores Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Scores', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/scores/:subresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
  
}]);
